import { laptopMax, mobileXLargeMax, tabletMax } from '@propertypal/shared/src/constants/mediaQueries';
import DevBg from '@propertypal/shared/src/resources/images/development-microsites/dev-hands.png';
import { Container as Button } from '@propertypal/web-ui/src/buttons/Button.style';
import { Content as PageWrapper } from '@propertypal/web-ui/src/layout/PageWrapper.style';
import { SubHeading, Text } from '@propertypal/web-ui/src/typography';
import styled from 'styled-components';

const PADDING_MOB = 80;
const IMG_BREAKPOINT = 1110;
const imgBreakpointMax = `max-width: ${IMG_BREAKPOINT}px`;
const imgBreakpointMin = `min-width: ${IMG_BREAKPOINT + 1}px`;

export const Container = styled.div<{
  dev?: boolean;
}>`
  background: ${({ theme }) => theme.primary};
  width: 100%;

  ${PageWrapper} {
    position: relative;
    padding: ${({ dev }) => (dev ? 180 : 150)}px 30px ${({ dev }) => (dev ? 180 : 120)}px 30px;

    @media (${imgBreakpointMax}) {
      padding: ${PADDING_MOB}px 15px;
    }
  }

  ${Text} {
    color: ${({ theme }) => theme.white};
    line-height: 1.42;
    max-width: 580px;
  }
`;

export const ContentText = styled.div<{ dev?: boolean }>`
  width: 100%;
  max-width: 640px;

  ${SubHeading} {
    color: ${({ theme }) => theme.white};
    line-height: 1.1;

    span {
      color: ${({ theme }) => theme.textDark};
    }

    @media (${laptopMax}) {
      font-size: 50px;
    }

    @media (${mobileXLargeMax}) {
      font-size: 40px;
    }
  }

  ${Text} {
    color: ${({ theme }) => theme.white};
    line-height: 1.42;
    max-width: ${({ dev }) => (dev ? 580 : 520)}px;
  }

  ${Button} {
    background-color: ${({ theme }) => theme.darkGrey};

    &:hover {
      background-color: ${({ theme }) => theme.backgroundMid};
    }
  }

  @media (${imgBreakpointMax}) {
    margin: 0 auto;
    text-align: center;

    ${Button}, ${Text} {
      margin-left: auto;
      margin-right: auto;
    }
  }
`;

export const BespokeImage = styled.div<{
  dev?: boolean;
}>`
  @media (${imgBreakpointMin}) {
    position: absolute;
    bottom: 0;
    right: 0;
    background-image: url(${DevBg.src});
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    height: 678px;
    width: 450px;
  }

  @media (${imgBreakpointMax}) {
    position: relative;
    width: 100%;
    height: 350px;

    &:after {
      content: '';
      position: absolute;
      bottom: -${PADDING_MOB}px;
      right: 0;
      background-image: url(${DevBg.src});
      background-position: center;
      background-size: contain;
      background-repeat: no-repeat;
      height: 560px;
      width: 328px;
    }
  }

  @media (${imgBreakpointMax}) {
    height: 500px;

    &:after {
      right: auto;
      left: 0;
      height: 540px;
      width: 100%;
    }
  }

  @media (${tabletMax}) {
    height: 350px;

    &:after {
      right: auto;
      left: 0;
      height: 390px;
      width: 100%;
    }
  }
`;
